export const icons = {
    "@where": "mdi:location",
    skill: "mdi:worker",
    frequency: "solar:calendar-bold-duotone",
    classification: "fa-solid:traffic-light",
}
